import { Action } from '@ngrx/store';

export enum CountDownActionTypes {
  UPDATE_COUNTER = '[CountDown] Update Count Down',
  CLEAR_COUNTER = '[CountDown] Clear Count Down'
}

export class UpdateCountDown implements Action {
  readonly type = CountDownActionTypes.UPDATE_COUNTER;
  constructor(public payload: number) {}
}

export class ClearCountDown implements Action {
  readonly type = CountDownActionTypes.CLEAR_COUNTER;
}

export type CountDownAction = UpdateCountDown | ClearCountDown;

export const fromCountDownActions = {
  UpdateCountDown,
  ClearCountDown
};
